 <template>
  <div id="app">
    <div v-if="checkSessionWithRouter" class="header-wrapper">
      <app-header v-on:openDialog="setShowDialog(true)" />
      <div v-if="!hideFilter">
        <div id="filter" class="container-fluid"></div>
      </div>
    </div>
    <div class="loading-app" v-if="isLoading">
      Loading..
    </div>
    <main v-else v-bind:class="{'container-fluid main-content': checkSessionWithRouter, 'background-blur': showTermsDialog, 'no-filter': hideFilter }">
      <router-view></router-view>
    </main>
    <Dialog
      title="Terms of Use"
      :visible.sync="showTermsDialog"
      width="720px"
      :show-close="false"
      :before-close="logout"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="default-dialog">
      <div class="dialog-content dialog-scroll" style="max-height:450px;">
        <iframe
          v-if="configuration && configuration.terms_and_conditions"
          :src="configuration.terms_and_conditions.transporter_s3_path"
          frameborder="0"
          style="border:0" width="100%" height="400px"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <Button type="secondary" size="mini" @click="logout();">Decline</Button>
        <Button type="primary" size="mini" @click="acceptTerms();">Accept</Button>
      </span>
    </Dialog>
    <Dialog
      class="modalblockbg newusermodal"
      title="Whats New?"
      :visible.sync="showDialog"
      width="40%"
      center>
      <NewTransporterLogin
        v-on:closeDialog = "setShowDialog(false)">
      </NewTransporterLogin>
    </Dialog>
    
    <!-- Portal target for file preview -->
    <portal-target name="file-preview"></portal-target>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import NewTransporterLogin from '@common/components/NewTransporterLogin';
import Header from '@/modules/common/Header';
import LoginValidation from '@/components/mixins/Login';
// import Firework from '@common/components/firework.vue';
import '@common/asset/icons';

import setLocale from './utils/localisation';

export default {
  components: {
    'app-header': Header,
    NewTransporterLogin,
  },
  data() {
    return {
      showDialog: false,
      dialogVisible: true,
    };
  },
  mixins: [LoginValidation],
  computed: {
    ...mapGetters({
      isLoggedIn: 'app/isLoggedIn',
      isLoading: 'app/isLoading',
      configuration: 'app/currentClientConfig',
      showTermsDialog: 'app/showTermsDialog',
      environmentVariables: 'app/environmentVariables',
      hideFilter: 'app/filterVisibility',
    }),
    checkSessionWithRouter() {
      return this.isLoggedIn && !['Map', 'HereMap'].includes(this.$router.history.current.name);
    },
  },
  async created() {
    try {
      if (this.$route.name === 'ResetPassword') {
        this.$store.commit('app/SET_FILTER_VISIBILITY', true);
      }
      const result = await this.$store.dispatch('app/bootstrap');
      if (result.status === 200) {
        this.$store.commit('app/SET_IS_PAYMENT_ERROR', false);
      }
      if (result.status === 402) {
        this.$store.commit('app/SET_IS_PAYMENT_ERROR', true);
        this.$router.push({ name: 'Login' });
      }
      if (
        result.current_user &&
        result.current_user.inlineManual[0] &&
        result.current_user.inlineManual[0].transporter_api_key
      ) {
        this.initializeInlineManual(result.current_user.inlineManual[0].transporter_api_key);
        window.inlineManualTracking = {
          uid: result.current_user.id,
          email: result.current_user.email,
          name: result.current_user.name,
        };
        // lazy loading the inline manual initializaion
        const id = setInterval(() => {
          const check = this.createmanual();
          if (check) {
            clearInterval(id);
          }
        }, 5000);
      }
      const passwordToBeReset = result.current_user.reset_password;
      if (passwordToBeReset) {
        this.$store.commit('app/SET_FILTER_VISIBILITY', true);
      }
      if (result.status === 401) {
        this.$router.push({ name: 'Login' });
      } else if (this.$router.history.current.name === 'Login') {
        this.validateRedirect(result);
      } else if (passwordToBeReset) {
        this.$router.push({ name: 'ResetPassword' });
      } else if (!result.current_user.has_accepted_terms_conditions &&
          result.client_config[0].terms_and_conditions &&
          result.client_config[0].terms_and_conditions.transporter_is_enabled) {
        this.$store.commit('app/SET_IS_PAYMENT_ERROR', false);
        this.$store.commit('app/SHOW_TERMS_DIALOG', true);
      } else {
        this.$store.commit('app/SET_IS_PAYMENT_ERROR', false);
      }
      await setLocale('en');
      return result;
    } catch (err) {
      return err;
    }
  },
  methods: {
    setShowDialog(value) {
      this.showDialog = value;
    },
    initializeInlineManual(apiKey) {
      try {
        const inlineWriterScriptElement = document.createElement('script');
        const t = document.getElementsByTagName('script')[0];
        inlineWriterScriptElement.setAttribute('async', 1);
        inlineWriterScriptElement.setAttribute('charset', 'UTF-8');
        t.parentNode.insertBefore(inlineWriterScriptElement, t);
        const baseUrl = this.environmentVariables.il_ml_base_url.replace('API_KEY', apiKey);
        inlineWriterScriptElement.setAttribute('src', baseUrl);
        document.head.appendChild(inlineWriterScriptElement);
      } catch (error) {
        console.log('Inline Manual Initialization Failed', error);
      }
    },
    createmanual() {
      try {
        // eslint-disable-next-line no-undef
        createInlineManualPlayer(window.inlineManualPlayerData);
        return true;
      } catch (error) {
        console.log('Error occured while initializing inline manual', error);
        return false;
      }
    },
    async logout() {
      this.$store.commit('app/SHOW_TERMS_DIALOG', false);
      const optimaHeaders = localStorage.getItem('Optima-selected-headers');
      const optimaInputPageHeaders = localStorage.getItem('optima-input-selected-headers');
      this.$store.dispatch('app/logout', { data: {}, noRedirect: true });
      const tableParameters = localStorage.getItem('tableParameters');
      localStorage.clear();
      if (tableParameters) {
        localStorage.setItem('tableParameters', tableParameters);
      }
      if (optimaHeaders) {
        localStorage.setItem('Optima-selected-headers', optimaHeaders);
      }
      if (optimaInputPageHeaders) {
        localStorage.setItem('optima-input-selected-headers', optimaInputPageHeaders);
      }
      localStorage.setItem('tsm-transporter-token', '');
      this.$router.push({ name: 'Login' });
    },
    async acceptTerms() {
      const result = await this.$store.dispatch('app/acceptTerms');
      this.$store.commit('app/SHOW_TERMS_DIALOG', false);
    },
  },

};
</script>
<style lang="scss">
@import 'vue-multiselect/dist/vue-multiselect.min.css';
@import '~@common/styles-transporter/app';
@import '~@common/style/apps';
@import '~@common/asset/style_v1/apps';

.header-wrapper {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10;
}

.main-content {
  background: #f8f8f8;
  margin-top: 100px;
  min-height: 100%;
  padding-top: 20px;
}

.no-filter {
  margin-top: 50px;
}

.loading-app {
  text-align: center;
  margin-top: 120px;
  font-size: 2rem;
}

.no-scroll {
  overflow: hidden;
}
</style>
